import { ShortcutHelper } from '@/services/helpers/ShortcutHelper'

export default defineNuxtPlugin(() => {
  // Instantiated here (outside any component) so their useLocalStorage listeners
  // don't get tied to, and torn down with, whichever component happens to mount first.
  useUserStore()
  useNewFeaturesStore().fetchFeatures()
  usePreferencesStore()
  const { isMobileDevice, isAppOrWebWithMobile, addDeepLinking, inviteToDownloadIfMobileBrowser } = useDeviceStore()
  isMobileDevice()
  isAppOrWebWithMobile()
  addDeepLinking()
  ShortcutHelper.init()
  inviteToDownloadIfMobileBrowser()
})
